/** H5 金融专区配置 */

import toubiaobaohan from './images/toubiaobaohan.jpeg';
import pinanyiliao from './images/pinanyiliao.png';
import piaojumiaotie from './images/piaojumiaotie.jpeg';
import lvyuebaohan from './images/lvyuebaohan.png';
import yufukuanbaohan from './images/yufukuanbaohan.png';
import shigonghetonglvyuebaoxian from './images/shigonghetonglvyuebaoxian.png';
import shigonghetongyufukuanbaoxian from './images/shigonghetongyufukuanbaoxian.png';
import shigonghetongzhiliangbaoxian from './images/shigonghetongzhiliangbaoxian.png';
import caigouhetongyufukuanbaoxian from './images/caigouhetongyufukuanbaoxian.png';
import caigouhetonglvyuebaoxian from './images/caigouhetonglvyuebaoxian.png';
import caigouhetongzhiliangbaoxian from './images/caigouhetongzhiliangbaoxian.png';

export interface H5BannerItem {
  key: string;
  title: string;
  subtitle: string;
  theme: 'blue' | 'orange' | 'green';
  image: string;
}

export interface H5ProductItem {
  id: string;
  name: string;
  brief: string;
  price: string;
  priceUnit: string;
}

export type H5CategoryTheme = 'guarantee' | 'insurance' | 'ticket';

export interface H5CategoryItem {
  key: H5CategoryTheme;
  name: string;
  desc: string;
  icon: string;
  theme: H5CategoryTheme;
  products: H5ProductItem[];
}

/** 默认展示产品数量，超出需展开 */
export const H5_DEFAULT_VISIBLE_COUNT = 3;

export const H5_BANNER_LIST: H5BannerItem[] = [
  {
    key: 'finance',
    title: '严选金融',
    subtitle: '保函 · 保险 · 票据 一站式企业服务\n最快当天出函 · 费率低至 0.3%',
    theme: 'blue',
    image: pinanyiliao,
  },
  {
    key: 'guarantee',
    title: '工程保函更省心',
    subtitle: '替代现金保证金\n释放企业流动资金 · 最快当天出函',
    theme: 'orange',
    image: toubiaobaohan,
  },
  {
    key: 'ticket',
    title: '票据融资就是快',
    subtitle: '5分钟到账 · 利率透明 · 全线上\n专属供应商票据融资服务',
    theme: 'green',
    image: piaojumiaotie,
  },
];

export const H5_CATEGORY_LIST: H5CategoryItem[] = [
  {
    key: 'guarantee',
    name: '保函服务',
    desc: '最快当天出函 · 费率低至 0.3%',
    icon: '🛡️',
    theme: 'guarantee',
    products: [
      {
        id: 'bid-guarantee',
        name: '投标保函',
        brief: '投标保证金替代，降低资金占用',
        price: '0.3%',
        priceUnit: '起',
      },
      {
        id: 'performance-guarantee',
        name: '履约保函',
        brief: '保障合同履约，增强信用等级',
        price: '0.5%',
        priceUnit: '起',
      },
      {
        id: 'advance-payment-guarantee',
        name: '预付款保函',
        brief: '保障预付款安全，合规必备',
        price: '0.5%',
        priceUnit: '起',
      },
    ],
  },
  {
    key: 'insurance',
    name: '保险服务',
    desc: '多保司比价 · 线上投保 · 当天生效',
    icon: '☂️',
    theme: 'insurance',
    products: [
      {
        id: 'pingan-medical-insurance',
        name: '平安百万医疗险',
        brief: '百万保额 · 家庭共享 · 重疾绿通',
        price: '了解更多',
        priceUnit: '',
      },
      {
        id: 'pingan-construction-performance',
        name: '施工合同履约保险',
        brief: '保障合同履约，降低违约风险',
        price: '了解更多',
        priceUnit: '',
      },
      {
        id: 'construction-advance-payment',
        name: '施工合同预付款保险',
        brief: '保障预付款安全，合规必备',
        price: '了解更多',
        priceUnit: '',
      },
      {
        id: 'construction-quality-insurance',
        name: '施工合同质量保险',
        brief: '工程质量保障，替代质保金',
        price: '了解更多',
        priceUnit: '',
      },
      {
        id: 'procurement-advance-insurance',
        name: '采购合同预付款保险',
        brief: '保障采购预付资金安全',
        price: '了解更多',
        priceUnit: '',
      },
      {
        id: 'procurement-performance-insurance',
        name: '采购合同履约保险',
        brief: '保障采购合同履约，增强信用',
        price: '了解更多',
        priceUnit: '',
      },
      {
        id: 'procurement-quality-insurance',
        name: '采购合同质量保险',
        brief: '采购质量保障，降低验收风险',
        price: '了解更多',
        priceUnit: '',
      },
    ],
  },
  {
    key: 'ticket',
    name: '票据秒贴',
    desc: '5分钟到账 · 利率透明 · 全线上',
    icon: '💰',
    theme: 'ticket',
    products: [
      {
        id: 'bank-acceptance',
        name: '银行承兑汇票贴现',
        brief: '银行信用背书，利率低、到账快',
        price: '2.8%',
        priceUnit: '起',
      },
    ],
  },
];

/** 联系我们 */
export const H5_CONTACT_INFO = {
  address: '湖北省鄂州市葛店开发区发展大道双创谷之星产业园项目04地块B区F-3号楼',
  phone: '0711-5900818',
  email: 'ycgyl-kf@cscec.com',
  website: 'www.3jyx.cn',
  websiteUrl: 'https://www.3jyx.cn',
};

/** 是否预发/生产环境 */
export function getIsPreOrProEnvironment(environment: string) {
  return !['zjst', 'zjdev', 'itipre', 'local'].includes(environment);
}

/** 保函立即办理外链（与 PC 端 Banner 进入保函一致） */
export function getH5GuaranteeApplyUrl() {
  const environment = process?.env?.ENV || 'local';
  const isTestEnv = !getIsPreOrProEnvironment(environment);
  if (isTestEnv) {
    return 'https://mall-st.3jyx.cn/ext1/quick?platformCode=K3TFRdqzOGkZ4jPHBZkDMlYr42HBM_XixZRiNAbsUAyyJlISXczghUBpKAim4AFx7xRgEJ2pRZ3XiVRWgw';
  }
  return 'https://www.3jyx.cn/ext1/quick?platformCode=FGj6FU2p0BZCwRyz0TGt92Xaj2i2-qYZgWskTdVG0ISF1YRUdK8C-TuAMXxM9XC7JEY4vCEP4YGIfub6VWES1rZYqZy1';
}

/** 票据秒贴立即办理外链（与 PC 端 Banner 进入票据一致） */
export const H5_TICKET_APPLY_URL =
  'https://microapp.orangebank.com.cn/ecs-h5/#/note-platform/WjU3MjE2/home';

/** 平安百万医疗险立即办理外链（与 PC 端保单详情一致） */
export const H5_PINGAN_MEDICAL_APPLY_URL =
  'https://emcs.pa18.com/v2/product/p_eLifeGeneral/index.html?appType=01&key=120260724157760857152056086';

/** 保险服务立即办理外链 */
export function getH5InsuranceApplyUrl(productId?: string) {
  if (productId === 'pingan-medical-insurance') {
    return H5_PINGAN_MEDICAL_APPLY_URL;
  }
  const environment = process?.env?.ENV || 'local';
  if (getIsPreOrProEnvironment(environment)) {
    return 'https://www.3jyx.cn/api/ifs/v1/thirdParty/authAndRedirect?appId=yun_fu_bao&page=order';
  }
  return 'https://mall-st.3jyx.cn/api/ifs/v1/thirdParty/authAndRedirect?appId=yun_fu_bao&page=order';
}

/** H5 产品详情页配置 */
export interface H5ProductDetail {
  id: string;
  name: string;
  brief: string;
  intro: string;
  features: string[];
  scenarios: string[];
  processes: string[];
  /** 详情页主题色，与分类对应 */
  theme: H5CategoryTheme;
  /** 详情页顶部轮播图，未配置时按 theme 取默认图 */
  banners?: string[];
}

/** 详情页默认轮播图：保函 / 保险 / 票据 */
export const H5_DETAIL_BANNER_MAP: Record<H5CategoryTheme, string[]> = {
  guarantee: [toubiaobaohan],
  insurance: [pinanyiliao],
  ticket: [piaojumiaotie],
};

/** 获取详情页轮播图 */
export function getH5DetailBanners(detail: H5ProductDetail) {
  if (detail.banners?.length) return detail.banners;
  return H5_DETAIL_BANNER_MAP[detail.theme] || [];
}

/** 保函/保险共用办理流程（详情页横向步骤文案） */
export const H5_COMMON_PROCESSES = ['提交申请', '审核评估', '选择机构', '缴纳费用', '出具保函'];

export const H5_PRODUCT_DETAIL_MAP: Record<string, H5ProductDetail> = {
  'bid-guarantee': {
    id: 'bid-guarantee',
    name: '投标保函',
    brief: '投标保证金替代，降低资金占用',
    intro:
      '投标保函是投标人按照招标文件要求，由银行或担保机构出具的书面保证文件。当投标人中标后拒绝签订合同或拒绝缴纳履约保证金时，招标人有权要求担保机构支付保证金金额。',
    features: [
      '线上申请，最快当天出函',
      '费率低至0.3%，行业最优',
      '多家银行/担保机构可选',
      '专业顾问一对一服务',
    ],
    scenarios: ['工程投标', '资金释放', '信用增强'],
    processes: H5_COMMON_PROCESSES,
    theme: 'guarantee',
  },
  'performance-guarantee': {
    id: 'performance-guarantee',
    name: '履约保函',
    brief: '保障合同履约，增强信用等级',
    intro:
      '履约保函是承包人向发包人提供的保证文件，确保承包人按照合同约定履行义务。如承包人违约，发包人可向担保机构索赔。',
    features: ['增强企业信用等级', '替代现金保证金', '线上快速办理', '多家机构比价'],
    scenarios: ['合同履约', '信用保障', '风险控制'],
    processes: H5_COMMON_PROCESSES,
    theme: 'guarantee',
    banners: [lvyuebaohan],
  },
  'advance-payment-guarantee': {
    id: 'advance-payment-guarantee',
    name: '预付款保函',
    brief: '保障预付款安全，合规必备',
    intro:
      '预付款保函是承包人向发包人提供的保证文件，确保承包人按照合同约定使用预付款。如承包人违约，发包人可向担保机构索赔预付款金额。',
    features: ['保障预付款安全', '满足合规要求', '快速出函', '费率优惠'],
    scenarios: ['预付款', '资金安全', '合规'],
    processes: H5_COMMON_PROCESSES,
    theme: 'guarantee',
    banners: [yufukuanbaohan],
  },
  'pingan-medical-insurance': {
    id: 'pingan-medical-insurance',
    name: '平安百万医疗险',
    brief: '百万保额 · 家庭共享 · 重疾绿通',
    intro:
      '平安百万医疗险提供高额医疗保障，覆盖住院、手术、特殊门诊等医疗费用，最高保额可达百万，支持家庭共享，并提供重疾绿色通道服务。',
    features: ['百万保额', '家庭共享', '重疾绿通', '多保司比价'],
    scenarios: ['医疗保障', '百万保额', '家庭共享'],
    processes: H5_COMMON_PROCESSES,
    theme: 'insurance',
  },
  'pingan-construction-performance': {
    id: 'pingan-construction-performance',
    name: '施工合同履约保险',
    brief: '保障合同履约，降低违约风险',
    intro:
      '施工合同履约保险是以施工合同履行义务为保险标的的保险，当施工方未能按合同约定履行义务时，由保险公司承担相应的赔偿责任，保障项目顺利进行。',
    features: ['履约保障', '降低风险', '增强信用', '快速理赔'],
    scenarios: ['履约保障', '施工合同', '信用增强'],
    processes: H5_COMMON_PROCESSES,
    theme: 'insurance',
    banners: [shigonghetonglvyuebaoxian],
  },
  'construction-advance-payment': {
    id: 'construction-advance-payment',
    name: '施工合同预付款保险',
    brief: '保障预付款安全，合规必备',
    intro:
      '施工合同预付款保险是为保障发包方支付的预付款安全而设立的保险，当承包方未能按合同约定履行义务时，由保险公司赔偿发包方预付资金损失。',
    features: ['资金安全保障', '合规必备', '快速理赔', '专业服务'],
    scenarios: ['预付款', '资金安全', '合规保障'],
    processes: H5_COMMON_PROCESSES,
    theme: 'insurance',
    banners: [shigonghetongyufukuanbaoxian],
  },
  'construction-quality-insurance': {
    id: 'construction-quality-insurance',
    name: '施工合同质量保险',
    brief: '工程质量保障，替代质保金',
    intro:
      '施工合同质量保险是以工程质量为保证标的的保险，当工程出现质量问题时由保险公司负责赔偿或修复，可有效替代传统质保金，释放企业资金压力。',
    features: ['质量保障', '替代质保金', '释放资金', '专业服务'],
    scenarios: ['质量保障', '质保金替代', '施工合同'],
    processes: H5_COMMON_PROCESSES,
    theme: 'insurance',
    banners: [shigonghetongzhiliangbaoxian],
  },
  'procurement-advance-insurance': {
    id: 'procurement-advance-insurance',
    name: '采购合同预付款保险',
    brief: '保障采购预付资金安全',
    intro:
      '采购合同预付款保险是为保障采购方支付的预付货款安全而设立的保险，当供应方未能按合同约定交货或提供服务时，由保险公司赔偿采购方预付资金损失。',
    features: ['资金安全', '采购保障', '合规必备', '灵活方案'],
    scenarios: ['预付款', '采购保障', '资金安全'],
    processes: H5_COMMON_PROCESSES,
    theme: 'insurance',
    banners: [caigouhetongyufukuanbaoxian],
  },
  'procurement-performance-insurance': {
    id: 'procurement-performance-insurance',
    name: '采购合同履约保险',
    brief: '保障采购合同履约，增强信用',
    intro:
      '采购合同履约保险是以采购合同履行义务为保险标的的保险，当采购方或供应方未能按合同约定履行义务时，由保险公司承担相应的赔偿责任。',
    features: ['履约保障', '信用增强', '降低风险', '专业服务'],
    scenarios: ['履约保障', '采购合同', '信用增强'],
    processes: H5_COMMON_PROCESSES,
    theme: 'insurance',
    banners: [caigouhetonglvyuebaoxian],
  },
  'procurement-quality-insurance': {
    id: 'procurement-quality-insurance',
    name: '采购合同质量保险',
    brief: '采购质量保障，降低验收风险',
    intro:
      '采购合同质量保险是以采购物品质量为保险标的的保险，当采购物品不符合合同约定的质量标准时，由保险公司承担相应的赔偿责任，降低采购验收风险。',
    features: ['质量保障', '验收风险', '采购保护', '快速理赔'],
    scenarios: ['质量保障', '采购合同', '验收保障'],
    processes: H5_COMMON_PROCESSES,
    theme: 'insurance',
    banners: [caigouhetongzhiliangbaoxian],
  },
  'bank-acceptance': {
    id: 'bank-acceptance',
    name: '银行承兑汇票贴现',
    brief: '银行信用背书，利率低、到账快',
    intro:
      '银行承兑汇票贴现是指持票人将未到期的银行承兑汇票转让给银行，银行扣除贴现利息后将余额支付给持票人的行为。',
    features: ['银行信用背书', '利率低至2.8%', '秒级到账', '全线上操作'],
    scenarios: ['银行承兑', '低利率', '快速到账'],
    processes: H5_COMMON_PROCESSES,
    theme: 'ticket',
  },
};

/** 按产品 id 查找产品及所属分类 */
export function findH5ProductById(productId?: string | string[]) {
  const id = Array.isArray(productId) ? productId[0] : productId;
  if (!id) return null;

  for (const category of H5_CATEGORY_LIST) {
    const product = category.products.find((item) => item.id === id);
    if (product) {
      return {
        product,
        categoryName: category.name,
        categoryKey: category.key,
        detail: H5_PRODUCT_DETAIL_MAP[id] ?? null,
      };
    }
  }
  return null;
}
